import type { RefObject } from "react"
import { useEffect, useState } from "react"

type Config = {
  /** @default true */
  isEnabled?: boolean

  /** @default undefined */
  rootMargin?: string
}

export const useOnScreen = (
  ref: RefObject<Element | null>,
  config: Config = {},
): boolean => {
  const [isIntersecting, setIntersecting] = useState<boolean>(false)

  useEffect(() => {
    const current = ref.current
    if (current && (config.isEnabled ?? true)) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry) return

          setIntersecting(entry.isIntersecting)
        },
        { rootMargin: config.rootMargin },
      )

      observer.observe(current)
      return () => observer.unobserve(current)
    }
  }, [ref, config.isEnabled, config.rootMargin])

  return isIntersecting
}
